import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfPollOptionsItem } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfPollOptionsItem';

/**
 * 트윗에 포함될 투표 정보 (선택 사항)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfPoll = {
  /** 투표 기간 (분 단위) */
  durationMinutes?: number;
  /** 투표 종료 일시 (ISO 8601 형식) */
  expiresAt?: string;
  /** 투표 종료 여부 */
  isExpired?: boolean;
  /** 투표 선택지 목록 (결과 제외) */
  options?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfPollOptionsItem[];
  /** 투표 고유 ID (백엔드에서 생성) */
  pollId?: string;
  /** 투표 질문 */
  question?: string;
  /** 총 투표수 (투표 후 또는 결과 조회 시 의미 있음) */
  totalVotes?: number;
  /**
   * 현재 사용자가 투표한 옵션 ID (null이면 투표하지 않음)
   * @nullable
   */
  userVotedOptionId?: string | null;
};
